import React from "react";
import styled from "styled-components";
import {ThumbsUp} from "react-feather";

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  position: fixed;
  overflow: hidden;
  z-index: 99999;
  background: black;
  opacity: 0.5;
  height: 100vh;
  width: 100vw;
`;



export const ContainerModal = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: 999999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

  padding:0;
  background: white;
  border-radius: 10px;
  height: 500px;
  width: 700px;
  
`;

export const Badge = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  z-index: 999999;
  height: 30px;
  width: 30px;
  background: #b4382b;
  justify-items: center;
  align-items: center;
  text-align: center;
  justify-content: center;
  
  
  div{
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: white;
  cursor: pointer;
    :hover{
         transform: scale(1.3);
         font-weight: bold;
  }
  }
  
  :hover{
         background: #ff1205;
  }


`;

export const Background= styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  overflow: hidden;
  z-index: 999999;
  background: black;
  opacity: 0.5;
  height: 100%;
  width: 100%;
`;

export const CardMsg = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: black;
  justify-items: center;
  align-items: center;
  justify-content: center;
  p{
  font-size: 20px;
  }
`;
export const Mensagem = () => {
    return(
        <CardMsg>
            <div><ThumbsUp size={'30px'} color={'green'}/></div>
            <p>
                Mensagem enviada com sucesso!
            </p>
        </CardMsg>
    )
}